import RescheduleAppointmentConfirmationContainer from './routes/confirmation/RescheduleAppointmentConfirmationContainer.js';
import RescheduleAppointmentRoot from './routes/default/RescheduleAppointmentRoot.js';

const routeMap = {
    '': RescheduleAppointmentRoot,
    confirmation: RescheduleAppointmentConfirmationContainer
};

export { routeMap };
//# sourceMappingURL=route-map.js.map
